import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { Modal, IconButton, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import { hideModal } from 'state/actions';
import { COLOR, MODAL } from 'config/constants';
import { useDispatch } from 'react-redux';

const useStyles = makeStyles({
  content: {
    padding: 50,
  },
  title: {
    fontFamily: 'FordAntenna-SemiBold',
    marginBottom: 20,
  },
  modal: {
    position: 'absolute',
    top: '50%',
    padding: 50,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    left: '50%',
    backgroundColor: COLOR.WHITE,
    borderRadius: 10,
    transform: 'translate(-50%, -50%)',
    height: 'auto',
    maxHeight: '60%',
    overflowY: 'auto',
    width: 'auto',
  },
  closeButton: {
    position: 'absolute',
    right: 8,
    top: 8,
    color: COLOR.LIGHT_BLUE,
    marginBottom: 10,
  },
});

function EditTestimonialsModal() {
  const intl = useIntl();
  const classes = useStyles();
  const dispatch = useDispatch();
  const fmtEditTestimonials = intl.formatMessage({ id: 'portal.editTestimonials' });

  const onClose = () => {
    dispatch(hideModal(MODAL.EDIT_TESTIMONIALS));
  };

  const content = () => {
    return (
      <Modal open>
        <div className={classes.modal}>
          <IconButton className={classes.closeButton} onClick={onClose}>
            <CloseIcon />
          </IconButton>
          <Typography className={classes.title}>{fmtEditTestimonials}</Typography>
        </div>
      </Modal>
    );
  };
  return <div className={classes.content}>{content()}</div>;
}
export default EditTestimonialsModal;
